// removed by extract-text-webpack-plugin
module.exports = {"Map":"Map_Map__1ST3","LinkButton":"Map_LinkButton__2JYQ","close-icon":"Map_close-icon__3S3m","DetailsBox":"Map_DetailsBox__Atxw","DetailsCard":"Map_DetailsCard__1Tom","MapBox":"Map_MapBox__1J-v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Map/Map.scss
// module id = 540
// module chunks = 0